import { render, staticRenderFns } from "./PoolTab.vue?vue&type=template&id=09584caa&"
import script from "./PoolTab.vue?vue&type=script&lang=js&"
export * from "./PoolTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09584caa')) {
      api.createRecord('09584caa', component.options)
    } else {
      api.reload('09584caa', component.options)
    }
    module.hot.accept("./PoolTab.vue?vue&type=template&id=09584caa&", function () {
      api.rerender('09584caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/tabs/PoolTab.vue"
export default component.exports